module.exports = __webpack_public_path__ + "img/ebook-kono.32ac9695.png";